module.exports = __webpack_public_path__ + "static/media/puppies.8bb33146.JPG";